import { Control } from "react-hook-form";
import SelectComponent from "@via/components/select/select";
import FormInputComponent from "@via/components/inputs/form-input-component";
import {
  FieldTypeEnum,
  InputComponentType,
  BOOLEAN_OPTIONS,
  INPUT_VALIDATION_RULES,
} from "@via/components/advanced-filter/helpers/types";
import { getInputComponentTypeForFieldType } from "@via/components/advanced-filter/helpers/utils";

interface ValueInputProps {
  control: Control<any>;
  name: string;
  fieldType: FieldTypeEnum;
  placeholder?: string;
  disabled?: boolean;
  label?: string;
}

export default function ValueInput({
  control,
  name,
  fieldType,
  placeholder = "Enter value...",
  disabled = false,
  label = "Value",
}: ValueInputProps) {
  // Get input component type based on field type
  const inputComponentType = getInputComponentTypeForFieldType(fieldType);

  // Render different input components based on field type
  switch (inputComponentType) {
    case InputComponentType.Boolean:
      return (
        <div>
          <label className="mb-4 flex items-center text-sm font-medium leading-6 text-gray-900">
            {label}
          </label>
          <SelectComponent
            control={control}
            name={name}
            options={BOOLEAN_OPTIONS}
            placeholder="Select value..."
            enableClear={false}
            readOnly={disabled}
          />
        </div>
      );

    case InputComponentType.Number:
      return (
        <FormInputComponent
          control={control}
          name={name}
          label={label}
          placeholder={placeholder}
          type="number"
          validations={INPUT_VALIDATION_RULES[InputComponentType.Number]}
          disabled={disabled}
        />
      );

    case InputComponentType.Date:
      return (
        <FormInputComponent
          control={control}
          name={name}
          label={label}
          placeholder={placeholder}
          type="date"
          validations={INPUT_VALIDATION_RULES[InputComponentType.Date]}
          disabled={disabled}
        />
      );

    case InputComponentType.Text:
    default:
      return (
        <FormInputComponent
          control={control}
          name={name}
          label={label}
          placeholder={placeholder}
          type="text"
          validations={INPUT_VALIDATION_RULES[InputComponentType.Text]}
          disabled={disabled}
        />
      );
  }
}
